









































































































































import { Component, Vue } from 'vue-property-decorator';
import LoadingDataCard from '@/vue-app/components/home-dashboard/LoadingDataCard.vue';
import FundingDetailsKuspitAccount
  from '@/vue-app/components/my-investment-dashboard/FundingDetailsKuspitAccount.vue';
import SowosPocketCardViewModel
  from '@/vue-app/view-models/components/my-investment-dashboard-v2/sowos-pocket-card-view-model';
import SowosPocketInfo from '@/vue-app/components/my-investment-dashboard-v2/SowosPocketInfo.vue';
import KuspitAccountLinkingModal
  from '@/vue-app/components/contract-savings/kuspit-account-linking/kuspitAccountLinkingModal.vue';

@Component({
  name: 'SowosPocketCard',
  components: {
    KuspitAccountLinkingModal,
    SowosPocketInfo,
    LoadingDataCard,
    FundingDetailsKuspitAccount,
    ContractSavings: () => import('@/vue-app/components/ContractSavings.vue'),
    PocketIsOnMaintenanceDialog: () => import('@/vue-app/components/my-investment-dashboard-v2/PocketIsOnMaintenanceDialog.vue'),
    ProductIsUnavailableToHireDialog: () => import('@/vue-app/components/my-investment-dashboard-v2/ProductIsUnavailableToHireDialog.vue'),
  },
})
export default class SowosPocketCard extends Vue {
  sowos_pocket_card_model= Vue.observable(new SowosPocketCardViewModel());

  created() {
    this.sowos_pocket_card_model.initialize();
  }
}
